<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="dialogTitle"
    data-e2e="dialog-edit-staff-task-list"
    @submit="onSubmit"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <hr-list-select
        v-model="editTaskList.taskList"
        class="col-12"
        :options="filteredCredentialTaskLists"
        :label="$t('staff.taskList.inputTaskListLabel')"
        :disable="isSaved"
        autofocus
        data-e2e="select-staff-task-list"
      />
    </div>

    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <!-- Saving with nothing chosen appended a row naming no checklist, which the save path stored
           and the list then showed as an unnamed entry. -->
      <hr-confirm-btn
        type="submit"
        :label="$t('common.buttonSave')"
        :disable="!canConfirm"
        data-e2e="btn-save-staff-task-list"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import { cloneDeep, get, isEmpty } from 'lodash';
import {
  HrConfirmBtn, HrDismissBtn, HrFormDialog, HrListSelect,
} from 'src/design-system';
import Credentialing from 'src/mixins/Credentialing';

export default {
  name: 'EditStaffTaskList',

  components: {
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
    HrListSelect,
  },

  mixins: [Credentialing],

  props: {
    taskList: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      editTaskList: {
        taskList: null,
        status: 'active',
      },
    };
  },

  computed: {
    // A row naming no checklist is stored by the save path and reads as an unnamed entry, so the
    // form refuses to hand one over rather than leaving the list to explain it.
    canConfirm() {
      return !isEmpty(this.editTaskList.taskList);
    }, // canConfirm()

    dialogTitle() {
      return isEmpty(this.taskList)
        ? this.$t('staff.taskList.textAddTitle')
        : this.$t('staff.taskList.textEditTitle');
    },

    isSaved() {
      return get(this.editTaskList, 'id', null) !== null;
    },

    filteredCredentialTaskLists() {
      return this.getFilteredTaskLists(this.editTaskList.taskList);
    },
  },

  watch: {
    taskList: {
      immediate: true,
      handler(newTaskList) {
        if (isEmpty(newTaskList)) {
          this.editTaskList = {
            taskList: null,
            status: 'active',
            editStatus: 'create',
          };
        } else {
          this.editTaskList = cloneDeep(newTaskList);
        }
      }, // taskList()
    },
  },

  methods: {

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      this.$emit('hide');
    },

    onSubmit() {
      if (!this.canConfirm) {
        return;
      }

      this.$emit('ok', this.editTaskList);
      this.hide();
    }, // onSubmit()

  },
};
</script>
